// src/router/AdminRouter.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AdminLayout } from "../layouts";
import {
  Auth,
  Page_Partner_Profile,
  Page_Partner_Institution,
  Page_Partner_Facturation,
  Page_Support_Partner,
  Page_Institution_Profile,
  Page_Institution_Therapists,
  Page_Institution_Patients,
  Page_Institution_Support,
  Page_Institution_Dashboard,
  Page_Institution_Documentacion,
  Page_Therapist_Salas,
  Page_Therapist_Evaluaciones,
  Page_Therapist_Pacientes,
  Page_Therapist_Terapia,
  Page_Therapist_Sesion,
  Page_Therapist_Dashboard,
  Page_Therapist_Documentacion,
  Page_UIMaterials,
  Page_Institution_Therapies,
} from "../pages/portal";

// ✅ IMPORTACIÓN DEL NUEVO COMPONENTE DE ENTRADA PÚBLICA
import { PublicEntry } from "../pages/Public/PublicEntry";

import { Page_Patient_Portal as PagePatientPortal } from "../pages/portal/Page_patient/Page_Patient_Portal/Page_Patient_Portal";
import { useAuth } from "../hooks";

export function AdminRouter() {
  const { user } = useAuth();
  const role = user?.user?.role || user?.role;

  // Función para inyectar un Page dentro de un Layout
  const loadLayout = (Layout, Page) => (
    <Layout>
      <Page />
    </Layout>
  );

  // Rutas específicas según el rol
  const roleRoutes = {
    admin: [
      {
        path: "register",
        element: loadLayout(AdminLayout, Page_Partner_Profile),
      }, // ejemplo legacy
    ],

    partner: [
      {
        path: "partner/register",
        element: loadLayout(AdminLayout, Page_Partner_Profile),
      },
      {
        path: "partner/institution",
        element: loadLayout(AdminLayout, Page_Partner_Institution),
      },
      {
        path: "partner/facturation",
        element: loadLayout(AdminLayout, Page_Partner_Facturation),
      },
      {
        path: "partner/support",
        element: loadLayout(AdminLayout, Page_Support_Partner),
      },
    ],

    institution: [
      {
        path: "inst/profile",
        element: loadLayout(AdminLayout, Page_Institution_Profile),
      },
      {
        path: "inst/therapists",
        element: loadLayout(AdminLayout, Page_Institution_Therapists),
      },
      {
        path: "inst/patients",
        element: loadLayout(AdminLayout, Page_Institution_Patients),
      },
      {
        path: "inst/therapies",
        element: loadLayout(AdminLayout, Page_Institution_Therapies),
      },
      {
        path: "inst/support",
        element: loadLayout(AdminLayout, Page_Institution_Support),
      },
      {
        path: "inst/metricas",
        element: loadLayout(AdminLayout, Page_Institution_Dashboard),
      },
      {
        path: "inst/documentacion",
        element: loadLayout(AdminLayout, Page_Institution_Documentacion),
      },
    ],

    therapist: [
      {
        path: "therapist/salas",
        element: loadLayout(AdminLayout, Page_Therapist_Salas),
      },
      {
        path: "therapist/evaluacion",
        element: loadLayout(AdminLayout, Page_Therapist_Evaluaciones),
      },
      {
        path: "therapist/pacientes",
        element: loadLayout(AdminLayout, Page_Therapist_Pacientes),
      },
      {
        path: "therapist/terapia",
        element: loadLayout(AdminLayout, Page_Therapist_Terapia),
      },
      {
        path: "therapist/terapia/sesion/:sessionId",
        element: loadLayout(AdminLayout, Page_Therapist_Sesion),
      },
      {
        path: "therapist/dashboard",
        element: loadLayout(AdminLayout, Page_Therapist_Dashboard),
      },
      {
        path: "therapist/documentacion",
        element: loadLayout(AdminLayout, Page_Therapist_Documentacion),
      },
    ],

    // ✅ NUEVO: portal paciente (1 sola página y sin layout)
    patient: [{ path: "patient", element: <PagePatientPortal /> }],

    // Compat por si algún sitio aún usa "patients"
    patients: [{ path: "patient", element: <PagePatientPortal /> }],
  };

  // FIX: si el backend dice que eres "revi", se usan rutas institution
  if (role === "revi") {
    roleRoutes.revi = roleRoutes.institution;
  }

  // Ruta por defecto según el rol
  const defaultPathByRole = {
    admin: "portal/register",
    partner: "portal/partner/register",
    institution: "portal/inst/profile",
    revi: "portal/inst/profile",
    therapist: "/portal/therapist/salas",

    // ✅ paciente: ruta única
    patient: "/portal/patient",
    patients: "/portal/patient",
  };

  const availableRoutes = roleRoutes[role] || [];
  const defaultPath = defaultPathByRole[role] || "auth";

  return (
    <Routes>
      {!user ? (
        <>
          <Route path="auth" element={<Auth />} />
          {/* CAMBIO CLAVE: La raíz ahora apunta a PublicEntry, no a Auth directo */}
          <Route path="/" element={<PublicEntry />} />

          {/* Cualquier 404 en estado público manda a la raíz (Landing) */}
          <Route path="*" element={<Navigate to="/" />} />
        </>
      ) : (
        <>
          {availableRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}

          <Route
            path="materials"
            element={loadLayout(AdminLayout, Page_UIMaterials)}
          />

          <Route path="/" element={<Navigate to={defaultPath} />} />
          <Route path="*" element={<Navigate to="/" />} />
        </>
      )}
    </Routes>
  );
}
